import { Autocomplete, Popper, PopperProps, TextField } from "@mui/material";

export type CommonFilterSelectOption = {
  label: string;
  id: number;
};

type Props = {
  options: CommonFilterSelectOption[];
  onSelect: (id: number | null) => void;
  sx?: any;
  label?: string;
  size?: "small" | "medium";
  labelFontSize?: string;
  value?: number | null;
};

const CommonFilterSelect = ({
  options,
  onSelect,
  sx,
  label = "",
  size = "small",
  labelFontSize = "1.0rem",
  value,
}: Props) => {
  const CustomPopper = (props: PopperProps) => {
    return (
      <Popper
        {...props}
        style={{
          ...props.style,
          width: props.anchorEl
            ? (props.anchorEl as HTMLElement).clientWidth
            : undefined,
          zIndex: 4000,
        }}
        placement="bottom-start"
      />
    );
  };
  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.label}
      value={options.find((opt) => opt.id === value) || null}
      onChange={(_, value) => onSelect(value ? value.id : null)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          size={size}
          InputLabelProps={{
            sx: { fontSize: labelFontSize },
          }}
        />
      )}
      PopperComponent={CustomPopper}
      fullWidth
      clearOnEscape
      sx={sx}
    />
  );
};

export default CommonFilterSelect;
